import React from 'react';
import type {ComponentProps} from 'react';

import {Lesson} from '@edume/magnificent';

import useFeatureFlag from '../../../../hooks/useFeatureFlags';
import {useSlideCanvasActions} from '../SlideCanvasActionsContext';

const {ImageSlide} = Lesson;

export const WrappedImageSlide = (
  props: Omit<
    ComponentProps<typeof ImageSlide>,
    'areDynamicSlidesEnabled' | 'onCanvasObjectMove' | 'onCanvasObjectRemove'
  >
) => {
  const areDynamicSlidesEnabled = useFeatureFlag('dynamicSlideFullScreenMedia');
  const {onCanvasObjectMove, onCanvasObjectReorder} = useSlideCanvasActions();
  return (
    <ImageSlide
      areDynamicSlidesEnabled={areDynamicSlidesEnabled}
      onCanvasObjectMove={onCanvasObjectMove}
      onCanvasObjectReorder={onCanvasObjectReorder}
      {...props}
    />
  );
};
